import strapi from './strapi'
import { toDomainHttpClient } from './toDomainHttpClient'

// meta 는 maxios 와 같이 트래킹용 쿼리 파라미터가 된다.
export const domainCmsHttpClient = toDomainHttpClient(strapi, { forwardMeta: true })
